export const APP_NAME = "Phone Board";
